/**
 * Standalone Task Manager feature.
 *
 * This folder is intentionally self-contained so the Task Manager UI can evolve
 * independently of the rest of the app. The page renders inside the existing
 * app chrome (shared TopNav + side nav); we only own the route content here.
 *
 * The page content (Workflow Overview cards, categories, etc.) is populated from
 * a backend API that is not integrated yet and will be built out later.
 */

export const TASK_MANAGER_ROUTE = "/taskmanager";
export const TASK_MANAGER_NAV_LABEL = "Task Management";
export const getTaskManagerAuditRoute = (dashboardId) =>
  `${TASK_MANAGER_ROUTE}/${dashboardId}/audit-logs`;
